<template>
    <v-dialog v-model="shows" v-bind="$attrs">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card class="rounded-0">
            <v-toolbar class="v-toolbar--border">
                <v-toolbar-title><slot name="tit" /></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="v-size--xx-large rounded-0" @click.stop="close"><u-icon>close</u-icon></v-btn>
            </v-toolbar>
            <div class="pa-16px">
                <slot />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import UIcon from "@/components/publish/styles/icons/u-icon.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";

export default {
    props: {},
    components: {
        UIcon,
        Tit,
    },
    data: () => {
        return {
            shows: false,
        };
    },
    mounted() {},
    methods: {
        close() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
